import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Button, ButtonGroup, Col, Row, Table } from "reactstrap";
import { OrderDropdownMenu } from ".";
import { Link } from "react-router-dom";

export default function WarehouseShippingScheduleConsignedGrid(props) {
  const [data, setData] = useState();
  const [working, setWorking] = useState(false);
  let alreadyDisplayedList = [];

  useEffect(() => {
    if (data !== props.data) {
      setData(props.data);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data]);

  function getExcel() {
    setWorking(true);
    props.exportXlsxCallback();
    setWorking(false);
  }

  return (
    <>
      <Row className="align-items-center">
        <Col className="transparent-background">
          <ButtonGroup className="float-end">
            {props.data && props.data.length && props.exportXlsxCallback && (
              <Button
                title="Download as .xlsx"
                className="shredButtonExcel float-end ms-2"
                onClick={() => getExcel()}
                disabled={working}
              >
                <FontAwesomeIcon icon="file-excel" size="lg" />
              </Button>
            )}
          </ButtonGroup>
        </Col>
      </Row>
      <Table size="sm" className="data-table">
        <thead className="table-header">
          <tr>
            <th style={{ width: "11%" }}>Order Number</th>
            <th style={{ width: "11%" }}>Customer</th>
            <th style={{ width: "5%" }}>Customer P/N</th>
            <th style={{ width: "5%" }}>Item</th>
            <th style={{ width: "5%" }}>
              <span>
                Ordered <br /> QTY
              </span>
            </th>
            <th style={{ width: "5%" }}>Freight Carrier</th>
          </tr>
        </thead>
        <tbody>
          {_.map(props.data, (dataCell, index) => {
            const alreadyDisplayed = _.includes(
              alreadyDisplayedList,
              dataCell.orderId
            );
            alreadyDisplayedList.push(dataCell.orderId);
            return (
              <tr
                key={`index-${index}`}
                className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}
              >
                {alreadyDisplayed ? (
                  // <td
                  //   className="data-cell shredLink fw-bold"
                  //   children={dataCell.orderId}
                  // />
                  <td></td>
                ) : (
                  <OrderDropdownMenu
                    invoiceNumber={null}
                    orderId={dataCell.orderId}
                    itemNumber={dataCell.itemNumber}
                    customerId={dataCell.customerId}
                    isScan={true}
                    scanCallback={props.scanCallback}
                    order={dataCell}
                    isConsigned={true}
                    orderType={2} //orderType={dataCell.orderType}  BOL Screen expects a 2 for consigned orders
                    itemLabel={dataCell.itemWithDesc}                    
                    customerLabel={`${dataCell.customerId}`}
                  />
                )}
                <td className="data-cell">                 
                  <Link
                  style={{textDecoration: "none"}}
                  className="shredLink fw-bold"
                  to={`/customer-dashboard/${dataCell.customerId}`}
                  >
                    {dataCell.customerIdName}
                  </Link>
                </td>
                <td className="data-cell" children={dataCell.customerItemNumber} />
                <td className="data-cell" children={dataCell.itemWithDesc} />
                <td className="data-cell" children={dataCell.totalQty} />
                <td className="data-cell" children={`${dataCell.shipMethod} - ${dataCell.shipPhone}`} />
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
}
